import { render, staticRenderFns } from "./formImgUpload.vue?vue&type=template&id=1b76610c"
import script from "./formImgUpload.vue?vue&type=script&lang=js"
export * from "./formImgUpload.vue?vue&type=script&lang=js"
import style0 from "./formImgUpload.vue?vue&type=style&index=0&id=1b76610c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports